var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Taxonomies", path: { name: "admin-taxonomies" } }],
          name: "Strains",
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "Strains" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "no-permission-wrapper",
                            { attrs: { show: !_vm.canCreateTaxonomies } },
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: {
                                    variant: "success",
                                    disabled: !_vm.canCreateTaxonomies,
                                  },
                                  on: { click: _vm.openNewModal },
                                },
                                [_vm._v("Add new Strain")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      fields: _vm.table_fields,
                      items: _vm.strains,
                      "table-class": "text-nowrap",
                      responsive: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(name)",
                        fn: function (data) {
                          return [
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v(_vm._s(data.item.name)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "primary",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openEditModal(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canDeleteTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "danger",
                                      disabled: !_vm.canDeleteTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.confirmDelete(data.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.edit_strain
        ? _c("admin-strain-edit-modal", {
            attrs: { strain: _vm.edit_strain, visible: "" },
            on: {
              cancel: function ($event) {
                _vm.edit_strain = null
              },
              success: _vm.onStrainEdited,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("admin-strain-add-modal", {
        ref: "newModal",
        on: { success: _vm.onStrainAdded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }